<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">歷史參數查詢</div>
      <div style="margin-top: 2rem">
        <commonQueryInput :inputItems="multiInputItems" :immediateInputValues="true" v-model:getValue="multiInputVal"
          v-model:getImmediateValue="immediateMultiInputVal"></commonQueryInput>
      </div>
      <div style="margin-top: 2rem">
        <queryResultTable :dateHour="true" :queryResultTableItems="queryResultTableItems" />
      </div>
      <div class="text-end my-3">
        <exportCsv :exportData="heatTreatmentInquireItems.flatMap(element => [
          { time: element.time, group: '設定值', ...element.value.set },
          { time: element.time, group: '實際值', ...element.value.act }
        ])" :exportDataTitle="heatTreatmentInquireFields.map((item) => item.label)"
          :exportFileName="exportFileName()" />
      </div>
      <div v-if="heatTreatmentInquireItems.length > 0" class="my-3 table-responsive"
        style="overflow-y: auto; max-height: 550px">
        <table class="ht-work-value-table">
          <thead class="">
            <tr class="stickyHeader">
              <th v-for="(item, index) in heatTreatmentInquireFields" :key="index" :style="{
          'writing-mode':
            item.key == 'time' ? 'horizontal-tb' : 'vertical-rl',
        }">
                {{ item.label }}
              </th>
            </tr>
          </thead>
          <template v-for="item in heatTreatmentInquireItems">
            <tr>
              <td rowspan="2" style="background-color: #ffffff">
                {{ item.time }}
              </td>
              <td style="min-width: 70px">設定值</td>
              <td v-for="(set_item, set_key) in item.value.set" :key="set_key">
                {{ set_item }}
              </td>
            </tr>
            <tr>
              <td style="min-width: 70px">實際值</td>
              <td v-for="(act_item, act_key) in item.value.act" :key="act_key" :style="{
          'background-color':
            act_key == 'quench_furn_temp1' ||
              act_key == 'quench_furn_temp2' ||
              act_key == 'tempering_furn_temp1' ||
              act_key == 'tempering_furn_temp2' ||
              act_key == 'carb_tank_temp'
              ? '#fff'
              : item.value.set[act_key] > 100
                ? item.value.set[act_key] + 30 < act_item ||
                  item.value.set[act_key] - 30 > act_item
                  ? '#c10000'
                  : item.value.set[act_key] + 15 < act_item ||
                    item.value.set[act_key] - 15 > act_item
                    ? '#ffc100'
                    : '#fff'
                : item.value.set[act_key] < 1
                  ? item.value.set[act_key] + 0.1 < act_item ||
                    item.value.set[act_key] - 0.1 > act_item
                    ? '#c10000'
                    : item.value.set[act_key] + 0.05 < act_item ||
                      item.value.set[act_key] - 0.05 > act_item
                      ? '#ffc100'
                      : '#fff'
                  : item.value.set[act_key] + 20 < act_item ||
                    item.value.set[act_key] - 20 > act_item
                    ? '#c10000'
                    : item.value.set[act_key] + 10 < act_item ||
                      item.value.set[act_key] - 10 > act_item
                      ? '#ffc100'
                      : '#fff',
          color:
            act_key == 'quench_furn_temp1' ||
              act_key == 'quench_furn_temp2' ||
              act_key == 'tempering_furn_temp1' ||
              act_key == 'tempering_furn_temp2' ||
              act_key == 'carb_tank_temp'
              ? '#4b8c80'
              : item.value.set[act_key] > 100
                ? item.value.set[act_key] + 30 < act_item ||
                  item.value.set[act_key] - 30 > act_item
                  ? '#fff'
                  : item.value.set[act_key] + 15 < act_item ||
                    item.value.set[act_key] - 15 > act_item
                    ? '#646569'
                    : '#4b8c80'
                : item.value.set[act_key] < 1
                  ? item.value.set[act_key] + 0.1 < act_item ||
                    item.value.set[act_key] - 0.1 > act_item
                    ? '#fff'
                    : item.value.set[act_key] + 0.05 < act_item ||
                      item.value.set[act_key] - 0.05 > act_item
                      ? '#646569'
                      : '#4b8c80'
                  : item.value.set[act_key] + 20 < act_item ||
                    item.value.set[act_key] - 20 > act_item
                    ? '#fff'
                    : item.value.set[act_key] + 10 < act_item ||
                      item.value.set[act_key] - 10 > act_item
                      ? '#646569'
                      : '#4b8c80',
        }">
                {{ act_item }}
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import queryResultTable from "@/components/queryResultTable.vue";
import stackBar from "@/components/stackBar.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    queryResultTable,
    stackBar,
    exportCsv,
    commonTable,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_htProcess"]);
    const device = computed(() => store.getters["selectOptions/get_device"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_device: (payload) => {
        store.dispatch("selectOptions/set_device", payload);
      },
    };

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "date", // date/dateBetween/text/select/time/month
      },
      {
        key: "time",
        label: "時間",
        type: "timeBetween",
        checkEmpty: true,
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: false,
        disableText: "-- 選擇機台 --",
        bindOptions: device,
      },
    ]);
    const immediateMultiInputVal = ref();

    //查詢結果表格資料
    const queryResultTableItems = ref([]);

    //熱處理參數資訊
    const heatTreatmentInquireFields = ref([]);
    const heatTreatmentInquireItems = ref([]);

    //匯出資料的檔案名稱
    const exportFileName = () => {
      let exportFileName = "";
      if (heatTreatmentInquireItems.value.length != 0) {
        exportFileName =
          "熱處理參數_" +
          queryResultTableItems.value[0].date +
          "_" +
          (queryResultTableItems.value[0].time == "-" ? "" : queryResultTableItems.value[0].time + "_") +
          (queryResultTableItems.value[0].oper == "-" ? "" : queryResultTableItems.value[0].oper + "_") +
          (queryResultTableItems.value[0].device == "-" ? "" : queryResultTableItems.value[0].device);
      }
      return exportFileName;
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        console.log(newValue);
        params["methods"] = "POST";
        params["whichFunction"] = "heatTreatmentInquire";
        params["startTime"] = newValue["date"]["startDate"];
        params["startMinTime"] = newValue["time"]["startTime"];
        params["endMinTime"] = newValue["time"]["endTime"];
        params["oper"] = newValue["oper"];
        newValue["deviceID"] != undefined
          ? (params["deviceID"] = newValue["deviceID"])
          : "";

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            queryResultTableItems.value = [
              {
                date: queryTableData.information[0].date,
                time: queryTableData.information[0].time,
                site: queryTableData.information[0].factory,
                oper: queryTableData.information[0].process,
                group: queryTableData.information[0].group,
                device: queryTableData.information[0].device,
              },
            ];
            heatTreatmentInquireFields.value = queryTableData.htWorkValueFields;
            heatTreatmentInquireItems.value = queryTableData.value;
          } else {
            queryResultTableItems.value = [];
            heatTreatmentInquireItems.value = [];
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    const startTime = ref("");
    const process = ref("");
    // 查詢機台
    watch(
      immediateMultiInputVal,
      (newValue) => {
        if (newValue.oper == "" || newValue.oper == null) {
          return;
        }
        if (process.value == newValue.oper) {
          return;
        }
        let params = {};
        params["user"] = loginData.value.account;
        params["vuePage"] = "selectoption";
        params["methods"] = "GET";
        params["whichFunction"] = "GetDeviceOption";
        if (newValue.oper != "" || newValue.oper != null) {
          params["process"] = newValue.oper;
        } else {
          params["process"] = "-";
        }
        methods.axiosAction(params).then(() => {
          let result = axiosResult.value;
          if (result["Response"] == "ok") {
            methods.set_device(result.QueryTableData.device);
            process.value = newValue.oper;
          } else {
            let returnData = {};
            returnData[params.process] = [];
            methods.set_device(returnData);
            startTime.value = "";
            process.value = "";
          }
        });
      },
      { deep: true }
    );

    return {
      multiInputVal,
      multiInputItems,
      immediateMultiInputVal,
      queryResultTableItems,
      heatTreatmentInquireFields,
      heatTreatmentInquireItems,
      exportFileName,
    };
  },
};
</script>

<style scoped>
.ht-inquery-result-table-detail th,
.ht-inquery-result-table-detail td {
  height: 2.5rem;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}

.ht-inquery-result-table-detail th:first-child,
.ht-inquery-result-table-detail td:first-child {
  border-left: 1px solid;
}

.ht-inquery-result-table-detail th:last-child,
.ht-inquery-result-table-detail td:last-child {
  border-right: 1px solid;
}

.ht-inquery-result-table-detail {
  margin-bottom: 0px;
}

.ht-inquery-result-table-detail thead th {
  font-size: 1rem;
  color: #000000;
  background-color: #cccccc;
}

.ht-inquery-result-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}

.ht-inquery-result-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}

.ht-work-value-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #000;
}

.ht-work-value-table td {
  vertical-align: middle !important;
  border: 1px solid #000;
}

.ht-work-value-table tr:nth-child(odd) {
  color: #4b8c80;
  background-color: #ffffff;
}

.ht-work-value-table tr:nth-child(even) {
  background-color: #f0f0f0;
}

.ht-work-value-table thead th {
  padding: 5px;
  font-size: 1rem;
  color: #ffffff;
  background-color: #4b8c80;
  border: 1px solid #000;
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle !important;
  min-width: 30px;
}

.sticky-thead {
  position: sticky;
  top: 0;
}
</style>
